<script>
import { fly } from 'svelte/transition';

export let width;
export let linkto;
export let click;
export let image;

image = image || './images/logo.png';

function openUrl(){
    let win = window.open(linkto, '_blank');
    win.focus();
}

function onclick(){
    if(click){
        click();
    } else {
        loadStartScene();
    }
}

function loadStartScene(){
    window.CC.krpano.call("loadscene(get(scene[0].name),null,get(skin_settings.loadscene_flags),get(skin_settings.loadscene_blend));");
}
</script>

<style>
    div {
        position: absolute;
        left: 20px;
        top: 20px;
        z-index: 750;
        cursor:pointer;
    }

    img {
        height: auto;
    }

    @media only screen and (max-width: 600px) {
        img{
            max-width: 140px;
        }
    }

</style>

<div on:click={onclick} transition:fly={{y: -300, duration: 500 }}>
    <img src={image} width={width} alt={linkto ? 'Go to our website' : 'Load the starting scene'}/>
</div>
